import AccountLayout from '@/layouts/AccountLayout.tsx';

const AccountSecurity = () => <AccountLayout title="Security">Security Form Here</AccountLayout>;

export default AccountSecurity;
